export enum ExpenseStatusEnum {
    PENDENTE = "Pendente",
    APROVADO = "Aprovado",
    NAO_APROVADO = "Não Aprovado",
    PAGO = "Pago",
}
